import styled from 'styled-components';
import {
  Container,
  typography,
  colors,
  mediaQueries,
  size
} from '@everlywell/leaves';

export const Wrapper = styled.div`
  margin: 0 auto;
  max-width: 864px;
`;

export const Title = styled.h2`
  ${typography.overlineText}
  color: ${colors.white};
  margin-bottom: ${size.sm}px;
  font-weight: ${typography.weight.book};
  line-height: 23px;

  ${mediaQueries.forTabletVerticalUp} {
    margin-bottom: ${size.xs1}px;
  }
`;

export const Description = styled.p`
  ${typography.h5Text};
  color: ${colors.white};
  font-weight: ${typography.weight.book};
  margin-bottom: ${size.sm}px;
  letter-spacing: 0.5px;

  ${mediaQueries.forTabletVerticalUp} {
    ${typography.h4Text};
    color: ${colors.white};
    font-weight: ${typography.weight.book};
    margin-bottom: ${size.xl3}px;
  }
`;